<template>
  <div>
    <b-container class="self-assesment labor-conditions">
      <b-row>
        <b-col xl="10" offset-xl="1">
          <b-form @submit.prevent="">
            <!-- Tipo de contrato -->
            <fieldset>
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/laborConditions_contract_icon.svg"
                    alt="algo"
                  />
                </div>
                <h4>
                  {{ $t("label_selfAssessment_laborConditions_numberTable") }}
                </h4>
                <h2>
                  {{
                    $t("label_selfAssessment_laborConditions_contract_title")
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_laborConditions_contract_title_toolTip"
                  />
                </h2>
              </div>
              <div class="table">
                <b-row class="table-header">
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_contract_colum_employmentStatus"
                        )
                      }}<template-tooltip
                        tooltip="label_selfAssessment_laborConditions_contract_colum_employmentStatus_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_contract_colum_contract"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_contract_colum_contract_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_contract_colum_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_contract_colum_women_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_contract_colum_men"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_contract_colum_men_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>
                <b-row class="row form-group align-items-baseline">
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_contract_full"
                        )
                      }}<template-tooltip
                        tooltip="label_selfAssessment_laborConditions_contract"
                      />
                    </p>
                  </b-col>
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_contract_full_permanent"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_contract_full_permanent_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_contract_full_permanent_women"
                      v-model="
                        selfAssessment_laborConditions_contract_full_permanent_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_FULL_TIME',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_contract_full_permanent_men"
                      v-model="
                        selfAssessment_laborConditions_contract_full_permanent_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_FULL_TIME',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="4" sm="4" md="4" />
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_contract_full_temporary"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_contract_full_temporary_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_contract_full_temporary_women"
                      v-model="
                        selfAssessment_laborConditions_contract_full_temporary_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_FULL_TIME',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_contract_full_temporary_men"
                      v-model="
                        selfAssessment_laborConditions_contract_full_temporary_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_FULL_TIME',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group subtotal">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_contract_full_subtotal"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_contract_full_subtotal_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="1"
                      v-model="
                        selfAssessment_laborConditions_contract_full_subtotal_women
                      "
                      min="0"
                      readonly
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="2"
                      v-model="
                        selfAssessment_laborConditions_contract_full_subtotal_men
                      "
                      min="0"
                      readonly
                    />
                  </b-col>
                </b-row>
                <b-row class="row form-group align-items-baseline">
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_contract_part"
                        )
                      }}<template-tooltip
                        tooltip="label_selfAssessment_laborConditions_contract"
                      />
                    </p>
                  </b-col>
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_contract_part_permanent"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_contract_part_permanent_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_contract_part_permanent_women"
                      v-model="
                        selfAssessment_laborConditions_contract_part_permanent_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_PART_TIME',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_contract_part_permanent_men"
                      v-model="
                        selfAssessment_laborConditions_contract_part_permanent_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_PART_TIME',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="row form-group align-items-baseline">
                  <b-col cols="4" sm="4" md="4" />
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_contract_part_temporary"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_contract_part_temporary_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_contract_part_temporary_women"
                      v-model="
                        selfAssessment_laborConditions_contract_part_temporary_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_PART_TIME',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_contract_part_temporary_men"
                      v-model="
                        selfAssessment_laborConditions_contract_part_temporary_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_PART_TIME',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <!--Subtotal-->
                <b-row class="form-group subtotal">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_contract_part_subtotal"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_contract_part_subtotal_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="3"
                      v-model="
                        selfAssessment_laborConditions_contract_part_subtotal_women
                      "
                      min="0"
                      readonly
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="4"
                      v-model="
                        selfAssessment_laborConditions_contract_part_subtotal_men
                      "
                      min="0"
                      readonly
                    />
                  </b-col>
                </b-row>
                <!--END-->
                <!--Total-->
                <b-row class="form-group subtotal">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      <b>{{
                        $t(
                          "label_selfAssessment_laborConditions_contract_total"
                        )
                      }}</b>
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_contract_total_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="5"
                      :value="contractTotalWomen"
                      readonly
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="6"
                      :value="contractTotalMen"
                      readonly
                    />
                  </b-col>
                </b-row>
                <!--END-->
                <!--Coincides-->
                <div>
                  <div>
                    <div class="row form-group subtotal">
                      <div class="col-6 col-sm-8 col-md-8">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_staff_department_coincidesWithTable1"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_staff_department_coincidesWithTable1_toolTip"
                          />
                        </p>
                      </div>
                      <div
                        v-if="coincidesWithTable1Women(contractTotalWomen)"
                        class="col col-sm-2 col-md-2"
                      >
                        <p style="color: #43a39c; text-align: center">
                          {{ $t("label_selfAssessment_yes") }}
                        </p>
                      </div>
                      <div v-else class="col col-sm-2 col-md-2">
                        <p style="color: #a62122; text-align: center">
                          {{ $t("label_selfAssessment_no") }}
                        </p>
                      </div>
                      <div
                        v-if="coincidesWithTable1Men(contractTotalMen)"
                        class="col col-sm-2 col-md-2"
                      >
                        <p style="color: #43a39c; text-align: center">
                          {{ $t("label_selfAssessment_yes") }}
                        </p>
                      </div>
                      <div v-else class="col col-sm-2 col-md-2">
                        <p style="color: #a62122; text-align: center">
                          {{ $t("label_selfAssessment_no") }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!--End Coincides-->
                <!--Differente-->
                <div>
                  <div
                    v-if="
                      coincidesWithTable1Women(contractTotalWomen) === false ||
                      coincidesWithTable1Men(contractTotalMen) === false
                    "
                    class="row form-group subtotal"
                  >
                    <div class="col-6 col-sm-8 col-md-8">
                      <p>
                        {{
                          $t(
                            "label_selfAssessment_staff_department_differenceTable1"
                          )
                        }}
                        <template-tooltip
                          tooltip="label_selfAssessment_staff_department_coincidesWithTable1_toolTip"
                        />
                      </p>
                    </div>
                    <div
                      v-if="
                        coincidesWithTable1Women(contractTotalWomen) === false
                      "
                      class="col col-sm-2 col-md-2"
                    >
                      <form-input-numeric
                        style="background: #ddb9b9; color: white"
                        :value="differenceWithTable1Women(contractTotalWomen)"
                        readonly
                      />
                    </div>
                    <div
                      v-if="
                        !coincidesWithTable1Women(contractTotalWomen) ===
                          false &&
                        coincidesWithTable1Men(contractTotalMen) === false
                      "
                      class="col col-sm-2 col-md-2"
                    />
                    <div
                      v-if="coincidesWithTable1Men(contractTotalMen) === false"
                      class="col col-sm-2 col-md-2"
                    >
                      <form-input-numeric
                        style="background: #ddb9b9; color: white"
                        :value="differenceWithTable1Men(contractTotalMen)"
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <!--End Differente-->
              </div>
            </fieldset>
            <!-- End - Tipo de contrato -->
            <!-- Politica Salarial -->
            <fieldset>
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/laborConditions_wages_icon.svg"
                  />
                </div>
                <h4>
                  {{
                    $t("label_selfAssessment_laborConditions_wages_numberTable")
                  }}
                </h4>
                <h2>
                  {{ $t("label_selfAssessment_laborConditions_wages_title") }}
                  <template-tooltip
                    tooltip="label_selfAssessment_laborConditions_wages_title_toolTip"
                  />
                </h2>
              </div>
              <div class="table">
                <b-row class="table-header">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_wages_column_averageGrossSalary"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_wages_column_averageGrossSalary_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_wages_colum_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_wages_colum_women_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_wages_colum_men"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_wages_colum_men_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>

                <b-row class="form-group align-items-baseline">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_wages_executiveDirector"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_wages_executiveDirector_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_executiveDirector_women"
                      v-model="
                        selfAssessment_laborConditions_wages_executiveDirector_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_executiveDirector_men"
                      v-model="
                        selfAssessment_laborConditions_wages_executiveDirector_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_wages_management"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_wages_management_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_management_women"
                      v-model="
                        selfAssessment_laborConditions_wages_management_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_management_men"
                      v-model="
                        selfAssessment_laborConditions_wages_management_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_wages_middleLevel4"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_wages_middleLevel4_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_middleLevel4_women"
                      v-model="
                        selfAssessment_laborConditions_wages_middleLevel4_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_middleLevel4_men"
                      v-model="
                        selfAssessment_laborConditions_wages_middleLevel4_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_wages_middleLevel3"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_wages_middleLevel3_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_middleLevel3_women"
                      v-model="
                        selfAssessment_laborConditions_wages_middleLevel3_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_middleLevel3_men"
                      v-model="
                        selfAssessment_laborConditions_wages_middleLevel3_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_wages_middleLevel2"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_wages_middleLevel2_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_middleLevel2_women"
                      v-model="
                        selfAssessment_laborConditions_wages_middleLevel2_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_middleLevel2_men"
                      v-model="
                        selfAssessment_laborConditions_wages_middleLevel2_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_wages_middleLevel1"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_wages_middleLevel1_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_middleLevel1_women"
                      v-model="
                        selfAssessment_laborConditions_wages_middleLevel1_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_middleLevel1_men"
                      v-model="
                        selfAssessment_laborConditions_wages_middleLevel1_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_wages_technical"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_wages_technical_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_technical_women"
                      v-model="
                        selfAssessment_laborConditions_wages_technical_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_technical_men"
                      v-model="
                        selfAssessment_laborConditions_wages_technical_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_wages_administrative"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_wages_administrative_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_administrative_women"
                      v-model="
                        selfAssessment_laborConditions_wages_administrative_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_administrative_men"
                      v-model="
                        selfAssessment_laborConditions_wages_administrative_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t("label_selfAssessment_laborConditions_wages_support")
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_wages_support_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_support_women"
                      v-model="
                        selfAssessment_laborConditions_wages_support_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_support_men"
                      v-model="selfAssessment_laborConditions_wages_support_men"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_wages_operational"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_wages_operational_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_operational_women"
                      v-model="
                        selfAssessment_laborConditions_wages_operational_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_wages_operational_men"
                      v-model="
                        selfAssessment_laborConditions_wages_operational_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WAGES',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
              </div>
            </fieldset>
            <!-- End - Politica Salarial -->
            <!--Tablet 7 WORKING PARENTS-->
            <fieldset>
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/laborConditions_workingParents_icon.svg"
                    alt="demographics"
                    title="demographics"
                  />
                </div>
                <div>
                  <h4>
                    {{
                      $t(
                        "label_selfAssessment_laborConditions_workingParents_numberTable"
                      )
                    }}
                  </h4>
                  <h2>
                    {{
                      $t(
                        "label_selfAssessment_laborConditions_workingParents_title"
                      )
                    }}
                    <template-tooltip
                      tooltip="label_selfAssessment_laborConditions_workingParents_title_toolTip"
                    />
                  </h2>
                </div>
              </div>
              <div class="table">
                <div class="row table-header">
                  <div class="col-6 col-sm-8 col-md-8" />
                  <div class="col col-sm-2 col-md-2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_workingParents_column_women"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_workingParents_column_men"
                        )
                      }}
                    </p>
                  </div>
                </div>
                <div class="row form-group align-items-baseline">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_workingParents_noWorkingParents"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_workingParents_noWorkingParents_toolTip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_workingParents_noWorkingParents_women"
                      v-model="
                        selfAssessment_laborConditions_workingParents_noWorkingParents_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WORKING_PARENTS',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_workingParents_noWorkingParents_men"
                      v-model="
                        selfAssessment_laborConditions_workingParents_noWorkingParents_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WORKING_PARENTS',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group align-items-baseline">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_workingParents_noSingleParents"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_workingParents_noSingleParents_toolTip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_workingParents_noSingleParents_women"
                      v-model="
                        selfAssessment_laborConditions_workingParents_noSingleParents_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WORKING_PARENTS',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_workingParents_noSingleParents_men"
                      v-model="
                        selfAssessment_laborConditions_workingParents_noSingleParents_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LC_WORKING_PARENTS',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
              </div>
            </fieldset>
            <!--END-->
            <!-- Medidas de conciliacion -->
            <fieldset class="compact">
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/laborConditions_leavePolicies_icon.svg"
                  />
                </div>
                <h4>
                  {{
                    $t(
                      "label_selfAssessment_laborConditions_leavePolicies_numberTable"
                    )
                  }}
                </h4>
                <h2>
                  {{
                    $t(
                      "label_selfAssessment_laborConditions_leavePolicies_title"
                    )
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_laborConditions_leavePolicies_title_toolTip"
                  />
                </h2>
              </div>

              <div class="table">
                <b-row class="table-header">
                  <b-col cols="11">
                    <b-row>
                      <b-col offset="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_leavePolicies_elegible_column_numberOfEligible"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_leavePolicies_elegible_column_numberOfEligible_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_leavePolicies_tookBenefit_column_numberTookBenefit"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_leavePolicies_tookBenefit_column_numberTookBenefit_toolTip"
                          />
                        </p>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_leavePolicies_column_policyExists"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_leavePolicies_column_policyExists_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>
                <b-row class="table-header">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_leavePolicies_column_policy"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_leavePolicies_column_policy_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_leavePolicies_elegible_colum_women"
                            )
                          }}
                          <template-tooltip tooltip="_toolTip" />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_leavePolicies_elegible_colum_men"
                            )
                          }}
                          <template-tooltip tooltip="_toolTip" />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_leavePolicies_tookBenefit_colum_women"
                            )
                          }}
                          <template-tooltip tooltip="_toolTip" />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_leavePolicies_tookBenefit_colum_men"
                            )
                          }}
                          <template-tooltip tooltip="_toolTip" />
                        </p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_leavePolicies_elegible_paternity"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_leavePolicies_elegible_paternity_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric id="7" placeholder="-" disabled />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_leavePolicies_elegible_paternity_men"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_elegible_paternity_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_leavePolicies_paternity_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_8',
                              'men',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric id="8" placeholder="-" disabled />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_leavePolicies_tookBenefit_paternity_men"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_tookBenefit_paternity_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_leavePolicies_paternity_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_8',
                              'men',
                              'took'
                            )
                          "
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists">
                    <input
                      id="selfAssessment_laborConditions_leavePolicies_paternity_policyExists"
                      v-model="
                        selfAssessment_laborConditions_leavePolicies_paternity_policyExists
                      "
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      :disabled="!canUpdateSelfAssessment"
                      @change="updateChekbox"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_leavePolicies_elegible_maternity"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_leavePolicies_elegible_maternity_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_leavePolicies_elegible_maternity_women"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_elegible_maternity_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_leavePolicies_maternity_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_8',
                              'women',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric id="9" placeholder="-" disabled />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_leavePolicies_tookBenefit_maternity_women"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_tookBenefit_maternity_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_leavePolicies_maternity_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_8',
                              'women',
                              'took'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric id="10" placeholder="-" disabled />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists">
                    <input
                      id="selfAssessment_laborConditions_leavePolicies_maternity_policyExists"
                      v-model="
                        selfAssessment_laborConditions_leavePolicies_maternity_policyExists
                      "
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      :disabled="!canUpdateSelfAssessment"
                      @change="updateChekbox"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_leavePolicies_elegible_breastfeeding"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_leavePolicies_elegible_breastfeeding_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_leavePolicies_elegible_breastfeeding_women"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_elegible_breastfeeding_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_leavePolicies_breastfeeding_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_8',
                              'women',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric id="11" placeholder="-" disabled />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_leavePolicies_tookBenefit_breastfeeding_women"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_tookBenefit_breastfeeding_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_leavePolicies_breastfeeding_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_8',
                              'women',
                              'took'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric id="12" placeholder="-" disabled />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists">
                    <input
                      id="selfAssessment_laborConditions_leavePolicies_breastfeeding_policyExists"
                      v-model="
                        selfAssessment_laborConditions_leavePolicies_breastfeeding_policyExists
                      "
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      :disabled="!canUpdateSelfAssessment"
                      @change="updateChekbox"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_leavePolicies_elegible_reductionWorkingHours"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_leavePolicies_elegible_reductionWorkingHours_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_leavePolicies_elegible_reductionWorkingHours_women"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_elegible_reductionWorkingHours_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_leavePolicies_reductionWorkingHours_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_8',
                              'women',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_leavePolicies_elegible_reductionWorkingHours_men"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_elegible_reductionWorkingHours_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_leavePolicies_reductionWorkingHours_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_8',
                              'men',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_leavePolicies_tookBenefit_reductionWorkingHours_women"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_tookBenefit_reductionWorkingHours_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_leavePolicies_reductionWorkingHours_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_8',
                              'women',
                              'took'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_leavePolicies_tookBenefit_reductionWorkingHours_men"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_tookBenefit_reductionWorkingHours_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_leavePolicies_reductionWorkingHours_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_8',
                              'men',
                              'took'
                            )
                          "
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists">
                    <input
                      id="selfAssessment_laborConditions_leavePolicies_reductionWorkingHours_policyExists"
                      v-model="
                        selfAssessment_laborConditions_leavePolicies_reductionWorkingHours_policyExists
                      "
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      :disabled="!canUpdateSelfAssessment"
                      @change="updateChekbox"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_leavePolicies_elegible_permittedLeave"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_leavePolicies_elegible_permittedLeave_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_leavePolicies_elegible_permittedLeave_women"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_elegible_permittedLeave_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_leavePolicies_permittedLeave_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_8',
                              'women',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_leavePolicies_elegible_permittedLeave_men"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_elegible_permittedLeave_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_leavePolicies_permittedLeave_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_8',
                              'men',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_leavePolicies_tookBenefit_permittedLeave_women"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_tookBenefit_permittedLeave_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_leavePolicies_permittedLeave_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_8',
                              'women',
                              'took'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_leavePolicies_tookBenefit_permittedLeave_men"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_tookBenefit_permittedLeave_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_leavePolicies_permittedLeave_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_8',
                              'men',
                              'took'
                            )
                          "
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists">
                    <input
                      id="selfAssessment_laborConditions_leavePolicies_permittedLeave_policyExists"
                      v-model="
                        selfAssessment_laborConditions_leavePolicies_permittedLeave_policyExists
                      "
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      :disabled="!canUpdateSelfAssessment"
                      @change="updateChekbox"
                    />
                  </b-col>
                </b-row>

                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_leavePolicies_other"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_leavePolicies_other_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="8" sm="8" cols="8">
                        <b-form-textarea
                          id="selfAssessment_laborConditions_leavePolicies_other"
                          v-model="
                            selfAssessment_laborConditions_leavePolicies_other
                          "
                          :disabled="!canUpdateSelfAssessment"
                          :rows="2"
                          @change.native="updateSelfAssessmentTextArea"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists" />
                </b-row>
              </div>
            </fieldset>
            <!-- End - Medidas de conciliacion -->
            <!-- Flexibilidad de tiempo -->
            <fieldset class="compact">
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/laborConditions_flexTime_icon.svg"
                  />
                </div>
                <h4>
                  {{
                    $t(
                      "label_selfAssessment_laborConditions_flexTime_numberTable"
                    )
                  }}
                </h4>
                <h2>
                  {{
                    $t("label_selfAssessment_laborConditions_flexTime_title")
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_laborConditions_flexTime_title_toolTip"
                  />
                </h2>
              </div>
              <div class="table">
                <b-row class="table-header">
                  <b-col cols="11">
                    <b-row>
                      <b-col offset="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_elegible_column_numberOfEligible"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_flexTime_elegible_column_numberOfEligible_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_tookBenefit_column_numberTookBenefit"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_flexTime_tookBenefit_column_numberTookBenefit_toolTip"
                          />
                        </p>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_flexTime_colum_policyExists"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_flexTime_colum_policyExists_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>
                <b-row class="table-header">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_column_policy"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_flexTime_column_policy_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_elegible_colum_women"
                            )
                          }}
                          <template-tooltip tooltip="_toolTip" />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_elegible_colum_men"
                            )
                          }}
                          <template-tooltip tooltip="_toolTip" />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_tookBenefit_colum_women"
                            )
                          }}
                          <template-tooltip tooltip="_toolTip" />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_tookBenefit_colum_men"
                            )
                          }}
                          <template-tooltip tooltip="_toolTip" />
                        </p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_flexibitilityArrivalDeparture"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_flexTime_flexibitilityArrivalDeparture_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_flexibitilityArrivalDeparture_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_flexibitilityArrivalDeparture_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_flexibitilityArrivalDeparture_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_flexibitilityArrivalDeparture_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_flexibitilityArrivalDeparture_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_flexibitilityArrivalDeparture_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_flexibitilityArrivalDeparture_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_flexibitilityArrivalDeparture_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_flexibitilityArrivalDeparture_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'took'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_flexibitilityArrivalDeparture_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_flexibitilityArrivalDeparture_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_flexibitilityArrivalDeparture_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'took'
                            )
                          "
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists">
                    <input
                      id="selfAssessment_laborConditions_flexTime_flexibitilityArrivalDeparture_policyExists"
                      v-model="
                        selfAssessment_laborConditions_flexTime_flexibitilityArrivalDeparture_policyExists
                      "
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      :disabled="!canUpdateSelfAssessment"
                      @change="updateChekbox"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_NegotiatedShedule"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_flexTime_NegotiatedShedule_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_NegotiatedShedule_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_NegotiatedShedule_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_NegotiatedShedule_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_NegotiatedShedule_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_NegotiatedShedule_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_NegotiatedShedule_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_NegotiatedShedule_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_NegotiatedShedule_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_NegotiatedShedule_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'took'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_NegotiatedShedule_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_NegotiatedShedule_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_NegotiatedShedule_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'took'
                            )
                          "
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists">
                    <input
                      id="selfAssessment_laborConditions_flexTime_NegotiatedShedule_policyExists"
                      v-model="
                        selfAssessment_laborConditions_flexTime_NegotiatedShedule_policyExists
                      "
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      :disabled="!canUpdateSelfAssessment"
                      @change="updateChekbox"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_reductionHours"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_flexTime_reductionHours_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_reductionHours_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_reductionHours_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_reductionHours_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_reductionHours_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_reductionHours_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_reductionHours_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_reductionHours_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_reductionHours_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_reductionHours_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'took'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_reductionHours_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_reductionHours_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_reductionHours_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'took'
                            )
                          "
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists">
                    <input
                      id="selfAssessment_laborConditions_flexTime_reductionHours_policyExists"
                      v-model="
                        selfAssessment_laborConditions_flexTime_reductionHours_policyExists
                      "
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      :disabled="!canUpdateSelfAssessment"
                      @change="updateChekbox"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_paidLeave"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_flexTime_paidLeave_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_paidLeave_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_paidLeave_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_paidLeave_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_paidLeave_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_paidLeave_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_paidLeave_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_paidLeave_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_paidLeave_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_paidLeave_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'took'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_paidLeave_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_paidLeave_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_paidLeave_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'took'
                            )
                          "
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists">
                    <input
                      id="selfAssessment_laborConditions_flexTime_paidLeave_policyExists"
                      v-model="
                        selfAssessment_laborConditions_flexTime_paidLeave_policyExists
                      "
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      :disabled="!canUpdateSelfAssessment"
                      @change="updateChekbox"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_unpaidLeave"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_flexTime_unpaidLeave_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_unpaidLeave_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_unpaidLeave_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_unpaidLeave_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_unpaidLeave_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_unpaidLeave_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_unpaidLeave_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_unpaidLeave_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_unpaidLeave_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_unpaidLeave_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'took'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_unpaidLeave_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_unpaidLeave_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_unpaidLeave_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'took'
                            )
                          "
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists">
                    <input
                      id="selfAssessment_laborConditions_flexTime_unpaidLeave_policyExists"
                      v-model="
                        selfAssessment_laborConditions_flexTime_unpaidLeave_policyExists
                      "
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      :disabled="!canUpdateSelfAssessment"
                      @change="updateChekbox"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_telecommuting"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_flexTime_telecommuting_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_telecommuting_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_telecommuting_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_telecommuting_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_telecommuting_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_telecommuting_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_telecommuting_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_telecommuting_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_telecommuting_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_telecommuting_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'took'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_telecommuting_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_telecommuting_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_telecommuting_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'took'
                            )
                          "
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists">
                    <input
                      id="selfAssessment_laborConditions_flexTime_telecommuting_policyExists"
                      v-model="
                        selfAssessment_laborConditions_flexTime_telecommuting_policyExists
                      "
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      :disabled="!canUpdateSelfAssessment"
                      @change="updateChekbox"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_transportationResidence"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_flexTime_transportationResidence_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_transportationResidence_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_transportationResidence_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_transportationResidence_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_transportationResidence_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_transportationResidence_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_transportationResidence_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_transportationResidence_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_transportationResidence_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_transportationResidence_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'took'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_transportationResidence_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_transportationResidence_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_transportationResidence_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'took'
                            )
                          "
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists">
                    <input
                      id="selfAssessment_laborConditions_flexTime_transportationResidence_policyExists"
                      v-model="
                        selfAssessment_laborConditions_flexTime_transportationResidence_policyExists
                      "
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      :disabled="!canUpdateSelfAssessment"
                      @change="updateChekbox"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_childCareAtCompany"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_flexTime_childCareAtCompany_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_childCareAtCompany_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_childCareAtCompany_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_childCareAtCompany_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_childCareAtCompany_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_childCareAtCompany_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_childCareAtCompany_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_childCareAtCompany_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_childCareAtCompany_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_childCareAtCompany_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'took'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_childCareAtCompany_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_childCareAtCompany_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_childCareAtCompany_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'took'
                            )
                          "
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists">
                    <input
                      id="selfAssessment_laborConditions_flexTime_childCareAtCompany_policyExists"
                      v-model="
                        selfAssessment_laborConditions_flexTime_childCareAtCompany_policyExists
                      "
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      :disabled="!canUpdateSelfAssessment"
                      @change="updateChekbox"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_externalChildCare"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_flexTime_externalChildCare_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_externalChildCare_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_externalChildCare_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_externalChildCare_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_elegible_externalChildCare_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_elegible_externalChildCare_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_externalChildCare_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'elegible'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_externalChildCare_women"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_externalChildCare_women
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_externalChildCare_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'women',
                              'took'
                            )
                          "
                        />
                      </b-col>
                      <b-col md="2" sm="2" cols="2">
                        <form-input-numeric
                          id="selfAssessment_laborConditions_flexTime_tookBenefit_externalChildCare_men"
                          v-model="
                            selfAssessment_laborConditions_flexTime_tookBenefit_externalChildCare_men
                          "
                          min="0"
                          required
                          :disabled="
                            !selfAssessment_laborConditions_flexTime_externalChildCare_policyExists ||
                            !canUpdateSelfAssessment
                          "
                          @change.native="
                            updateSingleFieldAndTotalize(
                              $event,
                              'SELFASSESMENT_LABORCONDITIONS_TABLE_9',
                              'men',
                              'took'
                            )
                          "
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists">
                    <input
                      id="selfAssessment_laborConditions_flexTime_externalChildCare_policyExists"
                      v-model="
                        selfAssessment_laborConditions_flexTime_externalChildCare_policyExists
                      "
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      :disabled="!canUpdateSelfAssessment"
                      @change="updateChekbox"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="11">
                    <b-row>
                      <b-col md="4" sm="4" cols="4">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_laborConditions_flexTime_other"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_laborConditions_flexTime_other_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col md="8" sm="8" cols="8">
                        <b-form-textarea
                          id="selfAssessment_laborConditions_flexTime_other"
                          v-model="
                            selfAssessment_laborConditions_flexTime_other
                          "
                          :disabled="!canUpdateSelfAssessment"
                          :rows="2"
                          @change.native="updateSelfAssessmentTextArea"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="1" class="policy-exists" />
                </b-row>
              </div>
            </fieldset>
            <!-- End - Flexibilidad de tiempo -->
            <!-- Prevención del acoso -->
            <fieldset>
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/laborConditions_preventingSexualHarassment_icon.svg"
                    alt="algo"
                  />
                </div>
                <h4>
                  {{
                    $t(
                      "label_selfAssessment_laborConditions_preventingSexualHarassment_numberTable"
                    )
                  }}
                </h4>
                <h2>
                  {{
                    $t(
                      "label_selfAssessment_laborConditions_harassmentDiscrimination_title"
                    )
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_title_toolTip"
                  />
                </h2>
                <div class="label">
                  {{
                    $t(
                      "label_selfAssessment_laborConditions_sexualHarassment_receivedResolved_subtitle"
                    )
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_laborConditions_sexualHarassment_receivedResolved_subtitle_toolTip"
                  />
                </div>
              </div>

              <!-- sexualHarassment -->
              <div class="table">
                <b-row class="table-header">
                  <b-col offset="4" md="4" sm="4" cols="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_sexualHarassment_received"
                        )
                      }}<template-tooltip
                        tooltip="label_selfAssessment_laborConditions_sexualHarassment_received_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col md="4" sm="4" cols="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_sexualHarassment_resolved"
                        )
                      }}<template-tooltip
                        tooltip="label_selfAssessment_laborConditions_sexualHarassment_resolved_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>
                <b-row class="table-header">
                  <b-col md="4" sm="4" cols="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_harassmentDiscrimination_subtitle_situation"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_subtitle_situation_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col md="2" sm="2" cols="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_harassmentDiscrimination_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_women_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col md="2" sm="2" cols="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_harassmentDiscrimination_men"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_men_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col md="2" sm="2" cols="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_harassmentDiscrimination_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_women_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col md="2" sm="2" cols="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_harassmentDiscrimination_men"
                        )
                      }}<template-tooltip
                        tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_men_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>

                <!-- duringRecruitment -->
                <div class="row form-group">
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_sexualHarassment_receivedResolved_recruitment"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_sexualHarassment_receivedResolved_recruitment_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_recruitment_received_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_recruitment_received_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'women',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_recruitment_received_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_recruitment_received_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'men',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_recruitment_resolved_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_recruitment_resolved_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'women',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_recruitment_resolved_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_recruitment_resolved_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'men',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                </div>
                <!-- duringRecruitmentEnd -->

                <!-- promotion -->
                <div class="row form-group">
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_sexualHarassment_receivedResolved_promotion"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_sexualHarassment_receivedResolved_promotion_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_promotion_received_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_promotion_received_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'women',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_promotion_received_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_promotion_received_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'men',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_promotion_resolved_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_promotion_resolved_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'women',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_promotion_resolved_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_promotion_resolved_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'men',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                </div>
                <!-- promotionEnd -->

                <!-- responsabilities -->
                <div class="row form-group">
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesCompany"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesCompany_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesCompany_received_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesCompany_received_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'women',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesCompany_received_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesCompany_received_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'men',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesCompany_resolved_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesCompany_resolved_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'women',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesCompany_resolved_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesCompany_resolved_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'men',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                </div>
                <!-- responsabilitiesEnd -->

                <!-- responsabilitiesChain -->
                <div class="row form-group">
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesChain"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesChain_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesChain_received_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesChain_received_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'women',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesChain_received_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesChain_received_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'men',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesChain_resolved_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesChain_resolved_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'women',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesChain_resolved_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesChain_resolved_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'men',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                </div>
                <!-- responsabilitiesChainEnd -->

                <!-- anotherSituation -->
                <div class="row form-group">
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_sexualHarassment_receivedResolved_other"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_sexualHarassment_receivedResolved_other_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_other_received_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_other_received_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'women',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_other_received_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_other_received_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'men',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_other_resolved_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_other_resolved_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'women',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_other_resolved_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_other_resolved_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED',
                          'men',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                </div>
                <!-- anotherSituationEnd -->

                <!-- total -->
                <b-row class="form-group subtotal">
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_sexualHarassment_receivedResolved_total"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_sexualHarassment_receivedResolved_total_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_total_received_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_total_received_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      readonly
                      @change.native="updateSAReceivedSexualHarassment"
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_total_received_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_total_received_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      readonly
                      @change.native="updateSAReceivedSexualHarassment"
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_total_resolved_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_total_resolved_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      readonly
                      @change.native="updateSAReceivedSexualHarassment"
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_receivedResolved_total_resolved_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_receivedResolved_total_resolved_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      readonly
                      @change.native="updateSAReceivedSexualHarassment"
                    />
                  </b-col>
                </b-row>
                <!-- totalEnd -->
              </div>
              <!-- sexualHarassmentEnd -->

              <div class="label">
                {{
                  $t(
                    "label_selfAssessment_laborConditions_sexualHarassment_position_subtitle"
                  )
                }}
                <template-tooltip
                  tooltip="label_selfAssessment_laborConditions_sexualHarassment_position_subtitle_toolTip"
                />
              </div>
              <!-- position -->
              <div class="table">
                <b-row class="table-header">
                  <b-col offset="8" md="2" sm="2" cols="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_harassmentDiscrimination_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_women_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col md="2" sm="2" cols="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_harassmentDiscrimination_men"
                        )
                      }}<template-tooltip
                        tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_men_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>

                <!-- position/subordinateOf -->
                <div class="row form-group">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_sexualHarassment_position_subordinateOf"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_sexualHarassment_position_subordinateOf_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_position_subordinateOf_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_position_subordinateOf_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_position_subordinateOf_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_position_subordinateOf_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </div>
                <!-- position/subordinateOfEnd -->

                <!-- position/superiorOf -->
                <div class="row form-group">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_sexualHarassment_position_superiorOf"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_sexualHarassment_position_superiorOf_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_position_superiorOf_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_position_superiorOf_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_position_superiorOf_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_position_superiorOf_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </div>
                <!-- position/superiorOfEnd -->

                <!-- position/peers -->
                <div class="row form-group">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_sexualHarassment_position_peers"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_sexualHarassment_position_peers_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_position_peers_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_position_peers_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_position_peers_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_position_peers_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </div>
                <!-- position/peersEnd -->

                <!-- position/otherHierarchical -->
                <div class="row form-group">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_sexualHarassment_position_otherHierarchical"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_sexualHarassment_position_otherHierarchical_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_position_otherHierarchical_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_position_otherHierarchical_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_position_otherHierarchical_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_position_otherHierarchical_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </div>
                <!-- position/otherHierarchicalEnd -->
                <!-- position/total -->
                <b-row class="form-group subtotal">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_sexualHarassment_position_total"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_sexualHarassment_position_total_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_position_total_women"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_position_total_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      read-only
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_sexualHarassment_position_total_men"
                      v-model="
                        selfAssessment_laborConditions_sexualHarassment_position_total_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      read-only
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <!-- position/totalEnd -->
              </div>
              <!-- positionEnd -->

              <div class="label">
                {{
                  $t(
                    "label_selfAssessment_laborConditions_genderDiscrimination_receivedResolved_subtitle"
                  )
                }}
                <template-tooltip
                  tooltip="label_selfAssessment_laborConditions_genderDiscrimination_receivedResolved_subtitle"
                />
              </div>
              <!-- genderDiscrimination -->
              <div class="table">
                <b-row class="table-header">
                  <b-col offset="4" md="4" sm="4" cols="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_genderDiscrimination_received"
                        )
                      }}
                    </p>
                    <template-tooltip
                      tooltip="label_selfAssessment_laborConditions_genderDiscrimination_received_toolTip"
                    />
                  </b-col>
                  <b-col md="4" sm="4" cols="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_genderDiscrimination_resolved"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_genderDiscrimination_resolved_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>

                <b-row class="table-header">
                  <b-col md="4" sm="4" cols="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_harassmentDiscrimination_subtitle_situation"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_subtitle_situation_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col md="2" sm="2" cols="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_harassmentDiscrimination_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_women_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col md="2" sm="2" cols="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_harassmentDiscrimination_men"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_men_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col md="2" sm="2" cols="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_harassmentDiscrimination_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_men_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col md="2" sm="2" cols="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_harassmentDiscrimination_men"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_men_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>

                <!-- genderDiscrimination/recruitment -->
                <b-row class="form-group">
                  <b-col md="4" sm="4" cols="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_genderDiscrimination_receivedResolved_recruitment"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_genderDiscrimination_receivedResolved_recruitment_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_recruitment_received_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_recruitment_received_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'women',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_recruitment_received_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_recruitment_received_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'men',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_recruitment_resolved_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_recruitment_resolved_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'women',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_recruitment_resolved_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_recruitment_resolved_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'men',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <!-- genderDiscrimination/recruitmentEnd -->

                <!-- genderDiscrimination/promotion -->
                <b-row class="form-group">
                  <b-col md="4" sm="4" cols="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_genderDiscrimination_receivedResolved_promotion"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_genderDiscrimination_receivedResolved_promotion_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_promotion_received_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_promotion_received_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'women',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_promotion_received_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_promotion_received_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'men',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_promotion_resolved_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_promotion_resolved_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'women',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_promotion_resolved_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_promotion_resolved_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'men',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <!-- genderDiscrimination/promotionEnd -->

                <!-- genderDiscrimination/responsabilities -->
                <b-row class="form-group">
                  <b-col md="4" sm="4" cols="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesCompany"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesCompany_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesCompany_received_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesCompany_received_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'women',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesCompany_received_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesCompany_received_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'men',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesCompany_resolved_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesCompany_resolved_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'women',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesCompany_resolved_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesCompany_resolved_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'men',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <!-- genderDiscrimination/responsabilitiesEnd -->

                <!-- genderDiscrimination/responsabilitiesChain -->
                <b-row class="form-group">
                  <b-col md="4" sm="4" cols="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesChain"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesChain_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesChain_received_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesChain_received_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'women',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesChain_received_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesChain_received_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'men',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesChain_resolved_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesChain_resolved_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'women',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesChain_resolved_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesChain_resolved_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'men',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <!-- genderDiscrimination/responsabilitiesChainEnd -->

                <!-- genderDiscrimination/other -->
                <b-row class="form-group">
                  <b-col md="4" sm="4" cols="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_genderDiscrimination_receivedResolved_other"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_genderDiscrimination_receivedResolved_other_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_other_received_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_other_received_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'women',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_other_received_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_other_received_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'men',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_other_resolved_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_other_resolved_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'women',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_other_resolved_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_other_resolved_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'men',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <!-- genderDiscrimination/otherEnd -->

                <!-- genderDiscrimination/total -->
                <b-row class="form-group subtotal">
                  <b-col cols="4" sm="4" md="4">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_genderDiscrimination_receivedResolved_total"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_genderDiscrimination_receivedResolved_total_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_total_received_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_total_received_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      read-only
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'women',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_total_received_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_total_received_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      read-only
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'men',
                          'received'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_total_resolved_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_total_resolved_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      read-only
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'women',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_receivedResolved_total_resolved_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_receivedResolved_total_resolved_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      read-only
                      @change.native="
                        updateSAReceivedSexualHarassment(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION',
                          'men',
                          'resolved'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <!-- genderDiscrimination/totalEnd -->
              </div>
              <!-- genderDiscriminationEnd -->

              <div class="label">
                {{
                  $t(
                    "label_selfAssessment_laborConditions_genderDiscrimination_position_subtitle"
                  )
                }}
                <template-tooltip
                  tooltip="label_selfAssessment_laborConditions_genderDiscrimination_position_subtitle_toolTip"
                />
              </div>
              <!-- genderDiscriminationPosition -->
              <div class="table">
                <b-row class="table-header">
                  <b-col offset="8" md="2" sm="2" cols="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_harassmentDiscrimination_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_women_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col md="2" sm="2" cols="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_harassmentDiscrimination_men"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_harassmentDiscrimination_men_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>

                <!-- genderDiscriminationPosition/subordinateOf -->
                <div class="row form-group align-items-baseline">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_genderDiscrimination_position_subordinateOf"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_genderDiscrimination_position_subordinateOf_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_position_subordinateOf_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_position_subordinateOf_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_position_subordinateOf_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_position_subordinateOf_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </div>
                <!-- genderDiscriminationPosition/subordinateOfEnd -->

                <!-- genderDiscriminationPosition/superiorOf -->
                <div class="row form-group align-items-baseline">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_genderDiscrimination_position_superiorOf"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_genderDiscrimination_position_superiorOf_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_position_superiorOf_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_position_superiorOf_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_position_superiorOf_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_position_superiorOf_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </div>
                <!-- genderDiscriminationPosition/superiorOfEnd -->

                <!-- genderDiscriminationPosition/peers -->
                <div class="row form-group align-items-baseline">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_genderDiscrimination_position_peers"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_genderDiscrimination_position_peers_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_position_peers_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_position_peers_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_position_peers_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_position_peers_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </div>
                <!-- genderDiscriminationPosition/peersEnd -->

                <!-- genderDiscriminationPosition/otherHierarchical -->
                <div class="row form-group align-items-baseline">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_genderDiscrimination_position_otherHierarchical"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_genderDiscrimination_position_otherHierarchical_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_position_otherHierarchical_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_position_otherHierarchical_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION',
                          'women'
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_position_otherHierarchical_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_position_otherHierarchical_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION',
                          'men'
                        )
                      "
                    />
                  </b-col>
                </div>
                <!-- genderDiscriminationPosition/otherHierarchicalEnd -->

                <!-- genderDiscriminationPosition/total -->
                <b-row class="form-group subtotal">
                  <b-col cols="8" sm="8" md="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_laborConditions_genderDiscrimination_position_total"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_laborConditions_genderDiscrimination_position_total_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_position_total_women"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_position_total_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      read-only
                      @change.native="updateSAGenderBasedDiscriminationPosition"
                    />
                  </b-col>
                  <b-col cols="2" sm="2" md="2">
                    <form-input-numeric
                      id="selfAssessment_laborConditions_genderDiscrimination_position_total_men"
                      v-model="
                        selfAssessment_laborConditions_genderDiscrimination_position_total_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      read-only
                      @change.native="updateSAGenderBasedDiscriminationPosition"
                    />
                  </b-col>
                </b-row>
                <!-- genderDiscriminationPosition/totalEnd -->
              </div>
              <!-- genderDiscriminationPositionEnd -->
            </fieldset>
            <!-- End - Prevención del acoso -->
          </b-form>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col lg="3">
          <b-button
            style="margin: 20px 0"
            to="/self-assessment/human-resources"
            variant="primary"
            block
          >
            {{ $t("label_selfAssessment_button_continue") }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { createHelpers } from "vuex-map-fields";
import { mapGetters, mapMutations } from "vuex";

import {
  SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED,
  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION,
  SELFASSESMENT_LABORCONDITIONS_TABLE_9,
  SELFASSESMENT_LABORCONDITIONS_TABLE_8,
} from "../../../constants/selfAssessmentLaborConditions.constants";
import { SELF_ASSESSMENT_LABOR_CONDITIONS } from "./store/assessment";
const { mapFields } = createHelpers({
  getterType: "getSelfAssessmentField",
  mutationType: "updateSelfAssessmentField",
});

export default {
  name: "SelfAssessmentLaborConditions",

  created: async function () {
    await this.$store.dispatch("SNAPSHOTS_GET");
    await this.$store.dispatch("BUSINESS_GET");
    this.$store
      .dispatch("SELF_ASSESSMENT_GET")
      .then(() => {
        this.$store.commit("setReloadSelfAssessment", false);
      })
      .catch((err) => {
        console.log(err);
        this.$router.push("/home"); // TODO Handle the error in a better way
      });
  },
  methods: {
    coincidesWithTable1Women: function (totalToCompareWomen) {
      if (
        this.selfAssessment_staff_responsibility_total_women ===
        totalToCompareWomen
      ) {
        return true;
      } else {
        return false;
      }
    },
    coincidesWithTable1Men: function (totalToCompareMen) {
      if (
        this.selfAssessment_staff_responsibility_total_men === totalToCompareMen
      ) {
        return true;
      } else {
        return false;
      }
    },
    differenceWithTable1Women: function (totalToCompareWomen) {
      return (
        this.selfAssessment_staff_responsibility_total_women -
        totalToCompareWomen
      );
    },
    differenceWithTable1Men: function (totalToCompareMen) {
      return (
        this.selfAssessment_staff_responsibility_total_men - totalToCompareMen
      );
    },
    updateSelfAssessmentTextArea: function (event) {
      var data = {};
      data[event.target.id] = event.target.value;

      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
    updateSAReceivedSexualHarassment: function (
      event,
      baseVariable,
      gender,
      receivedOrResolved
    ) {
      let baseConstant = null;
      let total = 0;
      let data = {};
      if (receivedOrResolved) {
        const superTotalBaseContantFields = [
          ...SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED[
            gender
          ][receivedOrResolved].fields,
          ...SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION[gender][
            receivedOrResolved
          ].fields,
        ];
        if (
          baseVariable ===
          "SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED"
        ) {
          baseConstant =
            SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED[gender][
              receivedOrResolved
            ];
        }

        if (
          baseVariable ===
          "SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION"
        ) {
          baseConstant =
            SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION[gender][
              receivedOrResolved
            ];
        }

        total = this.getTotal(baseConstant["fields"]);
        const superTotal = this.getTotal(superTotalBaseContantFields);
        data[baseConstant.total] = total;
        data[baseConstant.superTotal] = superTotal;
        this.setSelfAssessmentData({
          field: baseConstant.total,
          value: total,
        });
        this.setSelfAssessmentData({
          field: baseConstant.superTotal,
          value: superTotal,
        });
      } else {
        baseConstant = this.getBaseConstantFromDescription(baseVariable);
        data = this.updateSATotals(baseConstant, gender);
      }

      data[event.target.id] = parseInt(event.target.value);
      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
    getObjectToSendSHTotals: function () {},
    updateTotals: function () {
      var contractFullSubtotalWomen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_laborConditions_contract_full_permanent_women"
          ]
        ) || 0) +
        parseInt(
          this.selfAssessment[
            "selfAssessment_laborConditions_contract_full_temporary_women"
          ] || 0
        );
      var contractPartSubtotalWomen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_laborConditions_contract_part_permanent_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_laborConditions_contract_part_temporary_women"
          ]
        ) || 0);

      this.setSelfAssessmentData({
        field: "selfAssessment_laborConditions_contract_full_subtotal_women",
        value: contractFullSubtotalWomen,
      });
      this.setSelfAssessmentData({
        field: "selfAssessment_laborConditions_contract_part_subtotal_women",
        value: contractPartSubtotalWomen,
      });

      var contractFullSubtotalMen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_laborConditions_contract_full_permanent_men"
          ]
        ) || 0) +
        parseInt(
          this.selfAssessment[
            "selfAssessment_laborConditions_contract_full_temporary_men"
          ] || 0
        );
      var contractPartSubtotalMen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_laborConditions_contract_part_permanent_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_laborConditions_contract_part_temporary_men"
          ]
        ) || 0);

      this.setSelfAssessmentData({
        field: "selfAssessment_laborConditions_contract_full_subtotal_men",
        value: contractFullSubtotalMen,
      });
      this.setSelfAssessmentData({
        field: "selfAssessment_laborConditions_contract_part_subtotal_men",
        value: contractPartSubtotalMen,
      });
    },
    updateChekbox: function (event) {
      var data = {};
      var field = event.target.id;
      var fieldSplitElegible = field.split("_");
      var fieldSplitTookBenefit = field.split("_");
      if (!this.selfAssessment[field]) {
        fieldSplitElegible.splice(3, 0, "elegible");
        fieldSplitElegible.splice(-1, 1);
        var fieldElegibleMan = fieldSplitElegible.join("_") + "_men";
        var fieldElegibleWomen = fieldSplitElegible.join("_") + "_women";
        if (this.selfAssessment[fieldElegibleMan] !== undefined) {
          this.setSelfAssessmentData({ field: fieldElegibleMan, value: null });
          data[fieldElegibleMan] = null;
        }
        if (this.selfAssessment[fieldElegibleWomen] !== undefined) {
          this.setSelfAssessmentData({
            field: fieldElegibleWomen,
            value: null,
          });
          data[fieldElegibleWomen] = null;
        }
        fieldSplitTookBenefit.splice(3, 0, "tookBenefit");
        fieldSplitTookBenefit.splice(-1, 1);
        var fieldTookBenefitMan = fieldSplitTookBenefit.join("_") + "_men";
        var fieldTookBenefitWomen = fieldSplitTookBenefit.join("_") + "_women";
        if (this.selfAssessment[fieldTookBenefitMan] !== undefined) {
          this.setSelfAssessmentData({
            field: fieldTookBenefitMan,
            value: null,
          });
          data[fieldTookBenefitMan] = null;
        }
        if (this.selfAssessment[fieldTookBenefitWomen] !== undefined) {
          this.setSelfAssessmentData({
            field: fieldTookBenefitWomen,
            value: null,
          });
          data[fieldTookBenefitWomen] = null;
        }
      }
      data[field] = this.selfAssessment[field];
      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
    updateSingleField: function (event, baseVariable, gender) {
      const data = {};
      data[event.target.id] = parseInt(event.target.value);

      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
    updateSingleFieldAndTotalize: function (
      event,
      baseVariable,
      gender,
      subgroup
    ) {
      let base;
      switch (baseVariable) {
        case "SELFASSESMENT_LABORCONDITIONS_TABLE_9":
          base = SELFASSESMENT_LABORCONDITIONS_TABLE_9;
          break;
        case "SELFASSESMENT_LABORCONDITIONS_TABLE_8":
          base = SELFASSESMENT_LABORCONDITIONS_TABLE_8;
          break;
      }
      const total = this.getTotal(base[gender][subgroup]["fields"]);
      const data = {};
      data[base[gender][subgroup]["total"]] = total;
      data[event.target.id] = parseInt(event.target.value);
      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },

    updateByGenderSA: function (event, baseVariable, gender) {
      const baseConstant = this.getBaseConstantFromDescription(baseVariable);

      var data = this.updateSATotals(baseConstant, gender);
      data[event.target.id] = parseInt(event.target.value);
      console.log("TOTALS");
      console.log(data);
      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
    updateSATotals: function (variable, gender) {
      const response = {};
      if (variable[gender].subtotal) {
        const subtotal = this.getTotal(variable[gender].fields);
        response[variable[gender].subtotal] = subtotal;
        this.setSelfAssessmentData({
          field: variable[gender].subtotal,
          value: subtotal,
        });
      }

      if (variable[gender].total) {
        const total = this.getTotal(variable[gender].fields);
        response[variable[gender].total] = total;
        this.setSelfAssessmentData({
          field: variable[gender].total,
          value: total,
        });
      }

      return response;
    },
    getTotal: function (correspondingFields) {
      return this.getTotals(correspondingFields);
    },
    ...mapMutations(["setSelfAssessmentData", "setReloadSelfAssessment"]),
  },
  computed: {
    contractTotalWomen: function () {
      return (
        this.selfAssessment_laborConditions_contract_full_subtotal_women +
        this.selfAssessment_laborConditions_contract_part_subtotal_women
      );
    },
    contractTotalMen: function () {
      return (
        this.selfAssessment_laborConditions_contract_full_subtotal_men +
        this.selfAssessment_laborConditions_contract_part_subtotal_men
      );
    },
    ...mapGetters({
      selfAssessment: "getSelfAssessment",
      status: "getSelfAssessmentStatus",
      canUpdateSelfAssessment: "canUpdateSelfAssessment",
      getTotals: "getTotals",
      getBaseConstantFromDescription: "getBaseConstantFromDescription",
      getReloadSelfAssessment: "getReloadSelfAssessment",
    }),
    ...mapFields(SELF_ASSESSMENT_LABOR_CONDITIONS),
  },
};
</script>
